const UploadButton = () => {

    const buttons = document.querySelectorAll('.js-upload-button')

    if (!buttons) return
        ;
    [...buttons].forEach(button => {

        let content = button.querySelector('.js-upload-content')
        let originalContent = content.innerHTML
        let input = button.querySelector('.js-upload-input')
        let eraser = button.querySelector('.js-upload-eraser')

        button.addEventListener('change', () => {
            content.innerHTML = input.value.replace(/^.*\\/, '')

            if (input.files.length > 0 && input.files[0].size > 2000000) {
                window.alert(
                    'Het bestand is groter dan 2MB, probeer een kleiner bestand te versturen.',
                )
                input.value = ''
                content.innerHTML = 'Selecteer een kleiner bestand.'
            }

            if (input.value != '') {
                eraser.classList.add('active')
            }

            if (input.value == '') {
                content.innerHTML = originalContent
                eraser.classList.remove('active')
            }
        })

        eraser.addEventListener('click', () => {
            input.value = ''
            content.innerHTML = originalContent
            eraser.classList.remove('active')
        })

    })

}

export default UploadButton

// WEBPACK FOOTER //
// ./src/js/modules/UploadButton.js
